<h1 mat-dialog-title>
    <span [translate]="isCreation ? 'admin.voyages.referentiels.infos.headerTitleClasseCreation' : 'admin.voyages.referentiels.infos.headerTitleClasse'"
          [translateParams]="{ libelle: classe.code }"></span>
    <span [mat-dialog-close]="false"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content class="py-1">
    <form #form="ngForm">
        <fieldset>
            <div class="row">
                <custom-input ngDefaultControl
                              id="libelle"
                              name="libelle"
                              [(ngModel)]="classe.libelle"
                              customType="input"
                              rCol="2"
                              [readonly]="!classe.custom && !isCreation"
                              libelle="admin.voyages.referentiels.infos.libelle"
                              [required]="true"></custom-input>

                <custom-input ngDefaultControl
                              id="isActif"
                              name="isActif"
                              [ngModel]="classe.actif"
                              [(customModel)]="classe.actif"
                              customType="checkbox"
                              lCol="4"
                              rCol="2"
                              libelle="admin.voyages.referentiels.infos.actif"
                              [postTooltip]="'admin.voyages.referentiels.classesToolTip' | translate"></custom-input>
            </div>
            <div class="row">
                <custom-input ngDefaultControl
                              id="code"
                              name="code"
                              [(ngModel)]="classe.code"
                              customType="input"
                              rCol="2"
                              libelle="admin.voyages.referentiels.infos.code"
                              [readonly]="!classe.custom && !isCreation"
                              [required]="true"></custom-input>
                <custom-input *ngIf="!isCreation && classe.dateCreated"
                              ngDefaultControl
                              id="dateCreated"
                              name="dateCreated"
                              [ngModel]="classe.dateCreated"
                              [(customModel)]="classe.dateCreated"
                              customType="date"
                              lCol="4"
                              rCol="2"
                              [readonly]="true"
                              libelle="admin.voyages.referentiels.infos.dateCreation"></custom-input>
            </div>
            <div class="row">
                <custom-input ngDefaultControl
                              id="parite"
                              name="parite"
                              [(ngModel)]="classe.typePrestation"
                              customType="select"
                              rCol="2"
                              [selectOptions]="typesPrestation"
                              [readonly]="!classe.custom && !isCreation"
                              optionValue="id"
                              optionDisplay="libelle"
                              libelle="admin.voyages.referentiels.infos.typePrestation"></custom-input>
                <custom-input *ngIf="!isCreation && classe.dateUpdated"
                              ngDefaultControl
                              id="dateUpdated"
                              name="dateUpdated"
                              [ngModel]="classe.dateUpdated"
                              [(customModel)]="classe.dateUpdated"
                              customType="date"
                              lCol="4"
                              rCol="2"
                              [readonly]="true"
                              libelle="admin.voyages.referentiels.infos.derniereSynchronisation"></custom-input>
            </div>
        </fieldset>
    </form>
</div>
<div align="end" mat-dialog-actions>
    <button (click)="delete()" *ngIf="!this.isCreation && this.classe.custom" [disabled]="isSaving || isDeleting" color="warn" mat-stroked-button>
        <span *ngIf="!isDeleting" translate>global.actions.supprimer</span>
        <mat-spinner *ngIf="isDeleting" class="m-5" diameter="28"></mat-spinner>
    </button>
    <button (click)="save()" [disabled]="isSaving || isDeleting" color="primary" mat-flat-button>
        <span *ngIf="!isSaving" [translate]="'global.actions.enregistrer'"></span>
        <mat-spinner *ngIf="isSaving" class="m-5" diameter="28"></mat-spinner>
    </button>
</div>
